module.exports = __webpack_public_path__ + "components/rewards/insurance/static/logo-b33b310ddd7c3ac719a126b0bf9ba037.jpg";